"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.slice.js");

var _isNotString = _interopRequireDefault(require("./helpers/isNotString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * capitalize the first letter of a string, rest to lower
 *
 * @param str
 * @param lowerRest - lowerCase rest of string
 * @example
 * capitalizeFirst('some word') => 'Some word'
 */
var capitalizeFirst = function capitalizeFirst(str) {
  var lowerRest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if ((0, _isNotString.default)(str)) return '';
  return "".concat(str[0].toUpperCase()).concat(lowerRest ? str.slice(1).toLowerCase() : str.slice(1));
};

var _default = capitalizeFirst;
exports.default = _default;